module.exports = __webpack_public_path__ + "img/sqqy.6032e696.png";